const tabs = document.querySelector('.tabs');

if(tabs) {

  const tabButtons = tabs.querySelectorAll('[role="tab"]');
  const tabPanels = tabs.querySelectorAll('[role="tabpanel"]');


  function handleTabClick(event) {
    //hide all tabs.
    tabPanels.forEach((panel) => {
      panel.hidden = true;
    });

    //mark all tabs as unselected
    tabButtons.forEach((tab) => {
      tab.setAttribute('aria-selected', false);
    });

    // mark the clicked tab as selected
    event.currentTarget.setAttribute('aria-selected', true);

    //find the associated tab panel to show
    const { id } = event.currentTarget;

    const tabPanel = tabs.querySelector(`[aria-labelledby="${id}"]`);
    tabPanel.hidden = false;
  }

  if (tabButtons && tabPanels) {
    tabButtons.forEach((button) => {
      button.addEventListener('click',handleTabClick);
    });
  }
}